export const AirlineDemoColumns = [  
    { field: 'airline', headerName: 'Airline', width: 180, editable: false, sortable: false },  
    { field: 'transportationMethod', headerName: 'Domain', width: 180, editable: false, sortable: false },  
    { field: 'status', headerName: 'Status', width: 180, editable: false, sortable: false },  
    { field: 'flightNumber', headerName: 'Flight Number', width: 180, editable: false, sortable: false },  
    { field: 'departureLocation', headerName: 'Departure', width: 180, editable: false, sortable: false },  
    { field: 'destination', headerName: 'Destination', width: 180, editable: false, sortable: false },  
    { field: 'time', headerName: 'Arrival Time', width: 180, editable: false, sortable: false },  
  ];  
    
  export const AirlineDemoRows = [  
    {  
    id: 1,  
    airline: "airCanada",  
    transportationMethod: "flight",  
    status: "onTime",  
    flightNumber: "ac123",  
    departureLocation: "toronto",  
    destination: "vancouver",  
    time: "0800",  
    },  
    {  
    id: 2,  
    transportationMethod: "carService",  
    status: "delayed",  
    flightNumber: "ws456",  
    departureLocation: ">",  
    destination: "barcelona",  
    time: "1400",  
    },  
    {  
    id: 3,  
    transportationMethod: "*",  
    status: "scheduled",  
    flightNumber: "*",  
    departureLocation: "montreal",  
    destination: "paris",  
    time: "2000",  
    },  
    {  
    id: 4,  
    transportationMethod: "bus",  
    status: "cancelled",  
    flightNumber: "pd901",  
    departureLocation: "ottawa",  
    destination: "newYork",  
    time: "1200",  
    },  
    {  
    id: 5,  
    flightNumber: "wg234",  
    departureLocation: "edmonton",  
    destination: ">",  
    time: "1600",  
    },  
    {  
    id: 6,  
    flightNumber: "ac836",  
    destination: "london",  
    time: "0100",  
    },  
    {  
    id: 7,  
    flightNumber: "tw942",  
    destination: "dulin", 
    time: "2245",   
 
    },  
    {  
    id: 8,  
    destination: "amsterdam",  

    },  
    {  
    id: 9,  
    destination: "manila",  

    },  
    {  
    id: 10,  
    destination: "tokyo",  

    },  
  ];
  